export default "/images/fa01608807d9a68eebd9c64064561e56.avif";